import bbobHTML from '@bbob/html'
import presetHTML5 from '@bbob/preset-html5'
import list from './bbcodeHTML-list'
const replaceHtmlTags = (match) => {
  return match.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

export default (bbcodes, type) => {
  if (!bbcodes) { return '' }
  let onlyAllowTags = []

  let bbcode = replaceHtmlTags(bbcodes)

  if (bbcode && bbcode.length) {
    switch (type) {
      case 'minimal':
        onlyAllowTags = ['b', 'i', 'u', 'center', 'justify', 'left', 'right', 'url']
        bbcode = bbcode.replace(/\[p]/g, '')
        bbcode = bbcode.replace(/\[\/p]/g, '\n')
        break
      default:
        onlyAllowTags = ['p', 'b', 'i', 'list', '*', 'h2', 'h3', 'h4', 'table', 'tr', 'td', 'th', 'center', 'justify', 'left', 'right', 'url', 'quote']
        break
    }

    const preset = presetHTML5.extend((tags, options) => ({
      ...tags,
      list,
      center: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:center;'
        },
        content: node.content
      }),
      justify: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:justify;'
        },
        content: node.content
      }),
      left: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:left;'
        },
        content: node.content
      }),
      right: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:right;'
        },
        content: node.content
      }),
      table: (node) => {
        if (node.attrs && node.attrs.class && node.attrs.class === 'table') {
          return {
            tag: 'table',
            attrs: {
              class: 'table'
            },
            content: node.content
          }
        } else {
          return {
            tag: 'div',
            attrs: {
              class: 'table-container'
            },
            content: [{
              tag: 'table',
              attrs: {
                class: 'table'
              },
              content: node.content
            }]
          }
        }
      },
      quote: node => ({
        tag: 'div',
        attrs: {
          class: 'blockquote'
        },
        content: node.content
      })
    }))

    const options = {
      onlyAllowTags,
      enableEscapeTags: true
    }

    return bbobHTML(bbcode, preset(), options)
  } else {
    return ''
  }
}
